/**
 * NewsPuff
 */
import { Link as LinkBase } from 'ui-component-library/base';
import React from 'react';
import { Image } from 'ui-component-library/base';
import clsx from 'clsx';
import '../../web-components/block-link.js';
/** Main description for this component. */
var NewsPuff = function (_a) {
    var src = _a.src, alt = _a.alt, heading = _a.heading, text = _a.text, published = _a.published, className = _a.className, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h3' : _b, url = _a.url, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? LinkBase : _c, _d = _a.variant, variant = _d === void 0 ? 'standard' : _d, children = _a.children;
    var Heading = headingLevel;
    var Link = LinkComponent;
    return (React.createElement("article", { className: "mb-10 md:mb-16 cursor-pointer", "data-cid": "NewsPuff" },
        React.createElement("block-link", null,
            React.createElement("div", { className: clsx(!src && (variant === 'rounded' ? 'rounded h-43 mb-4' : 'h-52 mb-4')) }, src && (React.createElement(Image, { loading: "lazy", src: src + '?width=374', alt: alt, className: clsx(variant === 'rounded' ? 'rounded h-43' : 'h-52', 'image__object-fit') }))),
            React.createElement(Link, { to: url, className: "group block" },
                React.createElement(Heading, { className: "mt-0 mb-1 text-h3 text-primary-2 font-fontWeightLink group-hover:underline" }, heading)),
            (published || children) && (React.createElement("div", { className: "flex mb-1" },
                published && (React.createElement("span", { className: "whitespace-no-wrap text-p text-greyDarker" }, published)),
                children && React.createElement("ul", { className: " puff__categories" }, children))),
            React.createElement("p", { className: "text-p text-black" }, text))));
};
export default NewsPuff;
